import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, switchMap } from 'rxjs';
import { ConfigService } from '../config.service';
import { AssigneeService } from './assignee.service';
import { DataTransform } from './dataTransformFunctions';
import { Incident, IncidentReport, IncidentTypes } from './incidents.service';
import { IncidentServiceBase } from './incidentServiceBase';
import { LinkableLocationsService } from './linkable-locations.service';
import { WorkflowService } from './workflow.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalIncidentService extends IncidentServiceBase {

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    assigneeService: AssigneeService,
    workflowService: WorkflowService,
    locationService: LinkableLocationsService
  ) {
    super(assigneeService, workflowService, locationService);
  }



  getIncidentReport(incidentId: number) {
    return this.http.get<IncidentReport>(this.config.dataApiUrl + '/incident-reports/external/' + incidentId).pipe(
      switchMap((report: IncidentReport) => {
        return DataTransform.replaceIncidentDates(report.incident).pipe(
          switchMap(incident => {
            report.incident = incident;
            return of(report);
          })
        );
      }));
  }

  submitIncidentReport(newIncidentReport: IncidentReport,  type: IncidentTypes) {


    let reportType = "";
    switch (type) {
      case IncidentTypes.IncidentReportMissingPerson:
        reportType = "missing-person";
        newIncidentReport.incident.summary = "Missing Person Report";
        break;
      case IncidentTypes.IncidentReportWitness:
        reportType = "witness";
        newIncidentReport.incident.summary = "Witness Report";
        break;
      case IncidentTypes.IncidentReportStaffOrParticipant:
        reportType = "staff-or-participant";
        newIncidentReport.incident.summary = "Staff/Participant Report";
        break;
      case IncidentTypes.IncidentReportSupervisor:
        reportType = "supervisor";
        newIncidentReport.incident.summary = "Supervisor Report";
    }

    newIncidentReport.incident.priorityId = 2; //HACK: Hardcoded until we can implement default priorities

    newIncidentReport.incident.summary += " submitted by " + newIncidentReport.report.reporterFirstName + " " + newIncidentReport.report.reporterLastName;

    //clean up dates from non-required fields

    if (newIncidentReport.report['tripDate'] && newIncidentReport.report['tripDate'] == "") {
      delete newIncidentReport.report['tripDate'];
    }

    if (newIncidentReport.report['reporterWeight'] === null) {
      newIncidentReport.report['reporterWeight'] = -1;
    }

    return this.http.post(this.config.dataApiUrl + '/incident-reports/external/' + reportType + '/' + newIncidentReport.incident.workItemId, newIncidentReport);
  }



}
